import { ApiProperty } from '@nestjs/swagger';
import { Length } from 'class-validator';
import { DeviceNotificationInterface } from '../interfaces/device-notification.interface';

export class DeviceNotificationDto implements DeviceNotificationInterface {
  @ApiProperty({ type: 'string', title: 'Message Title' })
  @Length(3, 100)
  title!: string;

  @ApiProperty({ type: 'string', title: 'Message Body' })
  @Length(3, 100)
  message!: string;
}
